document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('[data-auria-menu-button]');
  const nav = document.querySelector('[data-auria-nav]');
  if (button && nav) button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });

  const catalog = document.querySelector('[data-auria-catalog]');
  if (!catalog) return;
  const categoryParams = new URLSearchParams(location.search);
  const viewCategory = { tops: 'TOPS', knitwear: 'KNITWEAR', bags: 'BAGS' }[categoryParams.get('view')];
  const selected = (categoryParams.get('category') || viewCategory || 'all').toUpperCase();
  const giftsPage = ['GIFTS', 'JEWELRY', 'APOTHECARY', 'HOME'].includes(selected);
  const giftFilters = catalog.querySelector('[data-gift-filters]');
  if (giftFilters) {
    giftFilters.hidden = !giftsPage;
    const giftSelect = giftFilters.querySelector('[data-gift-category]');
    if (giftSelect) {
      giftSelect.value = giftsPage ? selected : 'GIFTS';
      giftSelect.addEventListener('change', () => {
        const destination = new URL(giftSelect.dataset.rootUrl, location.origin);
        destination.searchParams.set('view', 'shop');
        destination.searchParams.set('category', giftSelect.value);
        location.assign(destination.href);
      });
    }
  }
  const titleData = catalog.querySelector('[data-catalog-titles]');
  const heading = catalog.querySelector('[data-catalog-heading]');
  if (heading && titleData) {
    const titles = JSON.parse(titleData.textContent);
    heading.textContent = giftsPage ? titles.GIFTS : titles[selected] || titles.ALL;
  }
  const cards = [...catalog.querySelectorAll('.auria-product-card')];
  let visible = 0;
  cards.forEach((card) => {
    const tags = (card.dataset.tags || '').toUpperCase().split('|');
    if (tags.includes('TSHIRTS')) tags.push('TOPS');
    const leatherSelected = selected === 'LEATHER' || selected === 'AFTERLIFE SERIES LEATHER';
    const giftsSelected = selected === 'GIFTS';
    const samplesSelected = selected === 'SAMPLES';
    const categoryMatch = tags.includes(selected) && !(selected === 'HOME' && tags.includes('APOTHECARY'));
    const show = selected === 'ALL' || categoryMatch ||
      (giftsSelected && tags.some(tag => ['HOME', 'APOTHECARY', 'JEWELRY', 'GIFTS'].includes(tag))) ||
      (samplesSelected && tags.includes('STUDIO SAMPLES')) ||
      (leatherSelected && tags.some(tag => tag === 'LEATHER' || tag === 'AFTERLIFE SERIES LEATHER'));
    card.hidden = !show;
    if (show) visible += 1;
  });
  catalog.querySelectorAll('[data-category-link]').forEach((link) => {
    link.classList.toggle('is-active', (link.dataset.categoryLink || '').toUpperCase() === selected);
  });
  const empty = catalog.querySelector('[data-filter-empty]');
  if (empty) empty.hidden = visible !== 0;
});
(() => {
  const init = () => {
    const hero = document.querySelector('.auria-editorial-hero');
    if (!hero) return;
    const panels = [hero, document.querySelector('.auria-editorial-gifts__destination')].filter(Boolean);
    let lastWidth;
    const lockHeight = () => {
      const width = document.documentElement.clientWidth;
      if (width === lastWidth) return;
      lastWidth = width;
      panels.forEach(panel => panel.style.removeProperty('height'));
      if (!window.matchMedia('(max-width: 700px)').matches) return;
      const height = getComputedStyle(hero).height;
      panels.forEach(panel => { panel.style.height = height; });
    };
    lockHeight();
    window.addEventListener('resize', lockHeight, { passive: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
